import { render, staticRenderFns } from "./IconTrendingDown.vue?vue&type=template&id=392fc90c"
import script from "./IconTrendingDown.vue?vue&type=script&lang=js"
export * from "./IconTrendingDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports